export const PRIMARY_COLOR = '#3B9CFF';
export const SECONDARY_COLOR = '#3B9CFF';
